import { ReduxService } from 'dashboard-services/services';

import { selectedUserDetailsBasicActions } from 'actions/modules/myAccount/selectedUser';

export const basicSelectedUserDetailsInitialState =  { 
  activated: undefined,
  authType: undefined,
  companyName: undefined,
  currentView: selectedUserDetailsBasicActions?.USER_DETAILS_VIEWS?.ROLES,
  lastLogged: undefined,
  status: undefined,
  sub: undefined,
  hasTriggeredPipelines: false,
  warehouse: undefined,
  triggeredPipelinesTotalSize: undefined
}

export default (state = basicSelectedUserDetailsInitialState, action) => {
  switch (action.type) {
    case selectedUserDetailsBasicActions.ON_CHANGE: {
          if(state[action.name] !== action.value) {
            return ReduxService.updateObject(state, { [action.name]: action.value })
          }
          return state;
        }
    case selectedUserDetailsBasicActions.ON_CURRENT_VIEW_CHANGE: 
      return ReduxService.updateObject(state, { currentView: action.value })
    case selectedUserDetailsBasicActions.CLEAN_ALL:
      return basicSelectedUserDetailsInitialState;
    default:
      return state; 
  }
}